import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetTransactionListReqData } from "./GetTransactionListReqData";
import { GetTransactionTotalsResData } from "./GetTransactionTotalsResData";

const ENDPOINT = "/cash_flow/transactions_total";

export class GetTransactionTotalsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetTransactionListReqData = null;

    constructor(payload: GetTransactionListReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetTransactionTotalsResData> {
        var res = await this.executeCommand(this.payload);
        return new GetTransactionTotalsResData(res);
    }
}
